import { useState } from 'react';
import type { LifecycleDiagnosticsItem } from '../types/lifecycle';

interface DiagnosticsTableProps {
  items: LifecycleDiagnosticsItem[];
}

const STATE_LABEL: Record<string, string> = {
  placeholder: 'Placeholder výstup',
  error: 'Chyba',
  no_pdf: 'Bez PDF',
  failed_retryable: 'Selhalo (znovu zkusí)',
};

export function DiagnosticsTable({ items }: DiagnosticsTableProps) {
  const [open, setOpen] = useState(false);
  return (
    <details
      className="diagnostics-table"
      open={open}
      onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}
    >
      <summary>
        Diagnostika: položky bez analýzy ({items.length}) — jen pro správce
      </summary>
      {items.length === 0 ? (
        <p className="diagnostics-table__empty">Žádné diagnostické položky.</p>
      ) : (
        <table className="diagnostics-table__table" role="table">
          <thead>
            <tr>
              <th>Klíč</th>
              <th>proposal_id</th>
              <th>Titulek</th>
              <th>Stav</th>
              <th>Chyba</th>
            </tr>
          </thead>
          <tbody>
            {items.map((d) => (
              <tr key={d.key}>
                <td><code>{d.key}</code></td>
                <td>{d.proposal_id ? <code>{d.proposal_id}</code> : <span className="muted">(bez ID)</span>}</td>
                <td>{d.title}</td>
                <td><span className={`badge badge--diag-${d.presentation_state}`}>{STATE_LABEL[d.presentation_state] || d.presentation_state}</span></td>
                <td className="diagnostics-table__error">{d.last_error ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </details>
  );
}
